import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerUserService } from '@wealthlane/api-services/wealthlane-customer-service';
import type { Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUsers } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetCustomerUserForSandbox = (
    handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
    | Array<{
        label: string;
        value: string;
    }>
    | undefined,
    unknown
> => {
    const customerUserForSandbox = useQuery(
        ['getCustomerUserForSandbox'],
        async () => {
            return await handleRequest(
                CustomerUserService.getApiCustomerApiAppCustomerUserCustomerUserForSandbox()
            );
        },
        {
            select: (data) => {
                return data?.map((user) => ({
                    label: user?.fullName ?? '',
                    value: user?.abpUserId ?? '',
                }));
            },
        }
    );

    return customerUserForSandbox;
};

export default useGetCustomerUserForSandbox;

